export default __webpack_public_path__ + "static/media/CFE.5ae79efc.png";